import React, { useEffect } from "react";
import Card from "components/card";
import AwardCard from "./AwardCard";
import { connect } from "react-redux";
import { getEmployeeAwardList } from "../../../../redux/employeeaward/employeeAwardState"
import dayjs from "dayjs";
import { Trophy } from "lucide-react";

const Awards = ({ recordList, pagination, doSearch }) => {

  useEffect(() => {
    doSearch({ paginate: pagination.per_page });
  }, [doSearch, pagination.per_page]);

  const filteredAwards = recordList?.filter((item) => item.ema_status_id === 1);

  return (
    <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200">
      <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
        <h4 className="leading-none flex items-center gap-2">
          <Trophy className="w-5 h-5 text-amber-600" />
          My Awards
        </h4>
        <p className="text-slate-700">Your achievements and recognition badges</p>
      </div>

      <div className="px-6 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {filteredAwards?.map((award) => (
            <AwardCard
              key={award.ema_id}
              title={award.award_title || "-"}
              date={award.ema_issued_at ? dayjs(award.ema_issued_at).format("MMMM YYYY") : "-"}
              icon={award.award_icon} 
              category={award.award_color_class}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
  requesting: state.employeeAward.employeeAwardList?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Awards);